import weeklyGLPostingFiltersSlice from './weeklyGLPostingFilters-slice';
export { defaultApprovedFilterState } from './weeklyGLPostingFilters-slice';

export const { setApprovedGLPostingFilters, resetApprovedGLPostingFiltersState } = weeklyGLPostingFiltersSlice.actions;

export default weeklyGLPostingFiltersSlice;
